






































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { mapGetters } from 'vuex';
import { configurationWebservice } from '../../../webservices/configuration';
import { User } from '../../../models/user';
import { Configuration } from '@/models/configuration';
import { ProposalMatch } from '@/models/proposalmatch';
import Proposal from '../proposal/Proposal.vue';

@Component({
    components: {
        Proposal,
    },
})
export default class EmailTheResults extends Vue {

    // Data
    public first_name: string = '';
    public last_name: string = '';
    public phone_number: string = '';
    public email: string = '';
    public comment: string = '';
    public genBtnOptions = {
       text : 'PDF herunterladen',
       url : '#',
       target : '',
       class: '',
       loading: false,
       generated: false,
    };

    // public followUp:boolean = false

    public errorMsg: string = '';

    protected disabled: boolean = false;
    protected isModalActive: boolean = false;
    protected emailSent: boolean = false;
    protected sendingEmail: boolean = false;

    @Getter('configuration/configuration') private configuration: Configuration;
    @Getter('configuration/proposalMatches') private proposalMatches: ProposalMatch[];

    @Getter('account/currentUser') private currentUser: User;
    @Mutation('account/setCurrentUser') private setCurrentUser;

    private generatePDF() {
        if ( this.genBtnOptions.generated ) {
            return 0;
        }
        this.storeTheResultsAndGenPdf(false);
    }

    private storeTheResultsAndGenPdf(followUp: boolean) {
        // If followUp is true Validate the user info
        if (followUp && !this.validateUserInput() || this.genBtnOptions.loading) {
            return 0;
        }

        this.genBtnOptions.text  = 'PDF wird generiert..';
        this.genBtnOptions.class  = 'fa';
        this.genBtnOptions.loading  = true;
        this.sendingEmail = true;

        const user: User = {
            first_name : this.first_name,
            last_name : this.last_name,
            email : this.email,
            phone_number : this.phone_number,
            password : '',
            password_confirmation : '',
        };

        this.setCurrentUser(user);

        configurationWebservice.sendConfiguration(user,
                                                  followUp,
                                                  this.comment,
                                                  this.configuration,
                                                  this.proposalMatches)
        .then((response) => {
            setTimeout(() => {
                this.sendingEmail = false;
                this.emailSent = true;
                this.editGenBtnOptions(response.data.fileName, user.email);
            }, 1000);
        });
    }

    private editGenBtnOptions(fileName, user_email) {
        // tslint:disable-next-line:max-line-length
        this.genBtnOptions.url = process.env.VUE_APP_API_URL + 'Salamander-Naturbad-Auswertung?filename=' + fileName;

        if (user_email !== '') {
             this.genBtnOptions.url += '&email=' + user_email;
        } else {
             this.genBtnOptions.url += '&email=guests';
        }

        this.genBtnOptions.target = '_blank';
        this.genBtnOptions.loading  = false;
        this.genBtnOptions.generated = true;
        this.genBtnOptions.text = 'Download';
        this.genBtnOptions.class = 'fa fa-download';
    }

    private toggleInfoModal(event) {
        this.isModalActive = !this.isModalActive;
        this.emailSent = false;
        this.errorMsg = '';
    }

    private validateUserInput() {
        if (this.first_name === '') {
            // this.errorMsg = 'Plaese enter your Name';
            this.errorMsg = 'first_name';
            return 0;
        } else if (this.last_name === '') {
            this.errorMsg = 'last_name';
            return 0;
        } else if (!this.validateEmail(this.email)) {
            this.errorMsg = 'email';
            return 0;
            /*
            // Currently disabled. Many swiss people are not used to add the number with +41 and use spaces often.
            } else if (!this.validatePhoneNumber(this.phone_number)) {
            this.errorMsg = 'phone_number';
            return 0;
            */
        } else {
            return true;
        }
    }

    private validateEmail(email) {
        // tslint:disable-next-line:max-line-length
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }

    private validatePhoneNumber(phone_number) {
        const re = /^(?:(?:|0{1,2}|\+{0,2})41(?:|\(0\))|0)([1-9]\d)(\d{3})(\d{2})(\d{2})$/;
        return re.test(phone_number.toLowerCase());
    }
}
